module.exports = __webpack_public_path__ + "static/media/no-experience.72d83ca4.svg";